"use strict";
/**
 * @module Services.LogRetrieval
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Server response from a FETCH_LOG_ENTRIES_SERVICE request.
 */
var EntriesFetchResponse = /** @class */ (function () {
    /**
     * Create a new EntriesFetchResponse instance
     *
     * @param firstEntry  the index of the first entry
     * @param entryCount  the number of entries that were fetched
     * @param fileId  the iteration of the data available from the provider
     * @param maxEntriesAvailable  the maximum available number of entries
     * @param firstLineNumber  the first line number
     * @param entries  the entries
     */
    function EntriesFetchResponse(firstEntry, entryCount, fileId, maxEntriesAvailable, firstLineNumber, entries) {
        this.firstEntry = firstEntry;
        this.entryCount = entryCount;
        this.fileId = fileId;
        this.maxEntriesAvailable = maxEntriesAvailable;
        this.firstLineNumber = firstLineNumber;
        this.entries = entries;
    }
    return EntriesFetchResponse;
}());
exports.EntriesFetchResponse = EntriesFetchResponse;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/log-retrieval/entries-fetch-response.js
// module id = 1970
// module chunks = 1